module.exports = __webpack_public_path__ + "img/login.2ecebbd7.png";